import { BCol } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

/** Bootstrap-vue bridge — replace this file with your own EgBCol when migrating. */
export const EgBCol = createEgBootstrapProxy("EgBCol", BCol);
